import {Directive, HostListener, OnDestroy, OnInit, output, input} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Directive({
    selector: '[appDebounceKeyup]'
})
export class DebounceKeyupDirective implements OnInit, OnDestroy {

    readonly debounceTime = input(500);
    readonly debounceKeyup = output<any>();

    private keyup = new Subject();
    private subscription$!: Subscription;

    ngOnInit(): void {
        this.subscription$ = this.keyup.pipe(debounceTime(this.debounceTime())).subscribe((e: any) => this.debounceKeyup.emit(e));
    }

    ngOnDestroy(): void {
        this.subscription$?.unsubscribe();
    }

    @HostListener('keyup', ['$event'])
    keyUpEvent(event: KeyboardEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.keyup.next(event);
    }
}
